/** @jsx jsx */

import { css, jsx } from '@emotion/core';

import { AsyncIndicator } from '@zapier/common-components';
import { Spacing } from '@zapier/theme';

const Styles = {
  root: css`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    margin-top: ${Spacing.unit}px;
  `,
};

export const LoadingBlock = () => (
  <div css={Styles.root}>
    <AsyncIndicator />
  </div>
);

LoadingBlock.displayName = 'LoadingBlock';

export default LoadingBlock;
